import { IGlobalLoadingInitialState } from "../types";



export const GlobalLoadingInitialState: IGlobalLoadingInitialState = {
    globalLoading: {},
    error: '',
    isLoading: false
}